import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import {Http} from '@angular/http';
import { log } from 'util';

@Injectable()
export class DataService {

  // Adding local variable to Http to use it inside class
  constructor(private http: Http) {
   }

  // this got envoked when any component needs the http request.
  public getData(url) {
    return this.http.get(url);
  }

  private buttonName = new BehaviorSubject<string>("Sort by Size");
  currentbuttonName = this.buttonName.asObservable();

  changebuttonName(name: string) {
    this.buttonName.next(name)
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/app-service/data.service.ts